import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { authAPI } from '../services/api';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';

export default function Register() {
  const [form, setForm] = useState({ email: '', username: '', password: '' });
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.email || !form.username || !form.password) {
      toast.error('لطفاً همه فیلدها را پر کنید');
      return;
    }
    if (form.password.length < 6) {
      toast.error('رمز عبور باید حداقل ۶ کاراکتر باشد');
      return;
    }
    setLoading(true);
    try {
      await authAPI.register(form.email, form.username, form.password);
      await login(form.email, form.password);
      toast.success('ثبت‌نام موفق! خوش اومدی 🎉');
      navigate('/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'خطا در ثبت‌نام');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">
          <h1>LinguaFlow</h1>
          <span>حساب جدید</span>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>ایمیل</label>
            <input
              name="email"
              type="email"
              placeholder="you@example.com"
              value={form.email}
              onChange={handleChange}
              autoFocus
            />
          </div>
          <div className="form-group">
            <label>نام کاربری</label>
            <input
              name="username"
              type="text"
              placeholder="مثلاً: ali_coder"
              value={form.username}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label>رمز عبور</label>
            <input
              name="password"
              type="password"
              placeholder="حداقل ۶ کاراکتر"
              value={form.password}
              onChange={handleChange}
            />
          </div>
          <button className="btn btn-primary" type="submit" disabled={loading} style={{ marginTop: '0.5rem' }}>
            {loading ? 'در حال ثبت‌نام...' : 'ثبت‌نام'}
          </button>
        </form>

        <div className="auth-switch">
          حساب داری؟
          <Link to="/login">وارد شو</Link>
        </div>
      </div>
    </div>
  );
}
